module.exports = __webpack_public_path__ + "static/media/dau-wau.5b0e8fbf.svg";